/** Wrap bare http(s) URLs in markdown link syntax so ReactMarkdown renders
 * them as anchors. Bumblebee status messages arrive as plain text ("Аналітика:
 * http://..."), and standard markdown leaves bare URLs unlinked. URLs already
 * inside a markdown link are left untouched. */
export function linkifyBareUrls(text: string): string {
	return text.replace(
		/\]\(https?:\/\/[^\s)]+\)|(https?:\/\/[^\s)]+)/g,
		(match, bareUrl) => (bareUrl ? `[${bareUrl}](${bareUrl})` : match),
	);
}
